import { Box } from "@mui/material"
import { SxProps } from "@mui/system"
import React from "react"

import {
  CuratedContentPageQuery,
  PublicationLevel,
} from "../../generated/graphql"
import useLiveConcertState from "../../hooks/use-live-concert-state"
import useTranslate from "../../hooks/use-translate"
import { DetailpageData } from "../../screens/Detail/DetailStore"
import { appStore } from "../../store/AppStore"
import { ArrayElement } from "../../types"
import { isTicketValid, s } from "../../utilities/common"
import { theme } from "../../utilities/theme"
import { Label, labelConfig } from "../Sliders/Teaser"

export const ContentLabels = ({
  publicationLevel,
  content,
  sx,
}: {
  publicationLevel?: PublicationLevel
  content?:
    | DetailpageData
    | Extract<
        ArrayElement<
          CuratedContentPageQuery["curatedContentPage"]["stageSlider"]
        >["item"],
        { __typename: "LiveConcert" }
      >
    | Extract<
        ArrayElement<
          CuratedContentPageQuery["curatedContentPage"]["stageSlider"]
        >["item"],
        { __typename: "VodConcert" }
      >
  sx?: SxProps
}) => {
  const { status } = useLiveConcertState(
    content?.__typename === "LiveConcert" ? content : undefined,
  )
  const currentUser = appStore((state) => state.currentUser)
  const t = useTranslate()

  if (!content) return null
  return (
    <Box
      sx={{
        "& > :not(:last-child)": {
          mr: s("10px"),
        },
        display: "flex",
        flexDirection: "row",
        ...sx,
      }}
    >
      {publicationLevel !== "TICKET_REQUIRED" &&
        // make sure that the client finished querying the user
        currentUser !== undefined &&
        !isTicketValid(currentUser?.ticket?.validUntil) && (
          <Label
            backgroundColor={theme.palette.white[70]}
            color={"black"}
            shadow
          >
            {t(labelConfig.Free)}
          </Label>
        )}
      {content?.__typename === "LiveConcert" && status !== "past" && (
        <Label
          shadow
          backgroundColor={theme.palette.black.accentRed}
          color={"white"}
        >
          {t(
            content.liveConcertType === "PREMIERE"
              ? labelConfig.Premiere
              : labelConfig.Live,
          )}
        </Label>
      )}
      {content.__typename === "VodConcert" || content.__typename === "Video" ? (
        <Label shadow backgroundColor={theme.palette.white[70]} color={"black"}>
          {content.typeDisplayName}
        </Label>
      ) : null}
    </Box>
  )
}
